// https://fordprofile.cms.dealer.com/sections/ford-blue-advantage-overview-atmbg-ca.htm
// Ford Blue Advantage California landing page tagging (US2013626 / DWPROJ-1043).
// Matches brochure download links by visible text so tagging survives PDF asset swaps.
export default {
	events: {
		'ddc.link.generic': [
			{
				// View Blue Certified Brochure PDF download
				logic: ({ eventData }) =>
					eventData?.text === 'View Blue Certified Brochure',
				payload: {
					directCall: 'global-download',
					payload: {
						onclick: {
							onclick:
								'used:si:cpo blue advantage california:brochure download:blue certified',
							onclickLinkName:
								'{client}:used:si:cpo blue advantage california:download'
						},
						page: {
							pageNameNoVehicle:
								'{client}:used:si:cpo blue advantage california'
						},
						event: {
							action: 'pdf brochure|tool'
						}
					}
				}
			},
			{
				// View 139-Point Inspection Checklist PDF download
				logic: ({ eventData }) =>
					eventData?.text === 'View 139-Point Inspection Checklist',
				payload: {
					directCall: 'global-download',
					payload: {
						onclick: {
							onclick:
								'used:si:cpo blue advantage california:brochure download:139 point checklist',
							onclickLinkName:
								'{client}:used:si:cpo blue advantage california:download'
						},
						page: {
							pageNameNoVehicle:
								'{client}:used:si:cpo blue advantage california'
						},
						event: {
							action: 'pdf brochure|tool'
						}
					}
				}
			}
		]
	}
};
